/**
 * AgentLoopView.tsx — CC 主舞台（Timeline + Spinner + 可选 TaskListFooter）
 *
 * 职责：
 *     /chat 与 /workflow 内 agent loop 区域共用投影与节点渲染。
 *
 * 链路位置：
 *     AgentSession · WorkflowSession scoped loop。
 *
 * 当前裁剪范围：
 *     workflow 页 showTaskListFooter=false（合并 Footer 在 P3）。
 */
import type { SessionTree } from '../../types/tree';
import { SessionTimeline } from '../SessionTimeline';
import { ScopedSessionStoreProvider } from './ScopedSessionStore';

export interface AgentLoopViewProps {
  /** 传入时使用隔离 store（workflow scoped）；省略则使用上层 SessionStoreContext */
  tree?: SessionTree;
  showTaskListFooter?: boolean;
  virtualized?: boolean;
  virtualizeThreshold?: number;
  groupParallelTools?: boolean;
}

function AgentLoopViewBody({
  showTaskListFooter = true,
  virtualized,
  virtualizeThreshold,
  groupParallelTools,
}: Omit<AgentLoopViewProps, 'tree'>) {
  return (
    <div className="lax-agent-loop-view" data-testid="lax-agent-loop-view">
      <SessionTimeline
        virtualized={virtualized}
        virtualizeThreshold={virtualizeThreshold}
        groupParallelTools={groupParallelTools}
        showTaskListFooter={showTaskListFooter}
      />
    </div>
  );
}

export function AgentLoopView({
  tree,
  showTaskListFooter = true,
  virtualized,
  virtualizeThreshold,
  groupParallelTools,
}: AgentLoopViewProps) {
  if (tree) {
    return (
      <ScopedSessionStoreProvider tree={tree}>
        <AgentLoopViewBody
          showTaskListFooter={showTaskListFooter}
          virtualized={virtualized}
          virtualizeThreshold={virtualizeThreshold}
          groupParallelTools={groupParallelTools}
        />
      </ScopedSessionStoreProvider>
    );
  }
  return (
    <AgentLoopViewBody
      showTaskListFooter={showTaskListFooter}
      virtualized={virtualized}
      virtualizeThreshold={virtualizeThreshold}
      groupParallelTools={groupParallelTools}
    />
  );
}
